export const SET_SLIDER_INDEX = 'SET_SLIDER_INDEX';

export function setSliderIndex(index) {
    return {
        type: SET_SLIDER_INDEX,
        index,
    };
}
